import request from 'local_modules/request'
import { constants } from 'helpers'
import { reducers, getState } from 'redux/core'


const setFetching = (isFetching) => reducers.marketplace.adminGroupsConfigPage.setFetching(isFetching)

const fetchGroups = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.learn + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminGroupsConfigPage.setGroups(data))
    .catch((error) => console.log(error))
}

const setGroups = (data) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.post(constants.marketplace.learn + `/${tool}`, data)
    .then(({ data }) => data)
    .catch((error) => console.log(error))
}

const fetchTrainers = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.environmentTrainer + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminGroupsConfigPage.setTrainers(data))
    .catch((error) => console.log(error))
}

const fetchTariffs = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.learnTariff + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminGroupsConfigPage.setTariffs(data))
    .catch((error) => console.log(error))
}


export default {
  setFetching,
  setGroups,
  fetchGroups,
  fetchTariffs,
  fetchTrainers,
}
